import { Bar, BarConfig } from '@ant-design/plots';
import { useQuery } from '@apollo/client';
import { GET_TRENDING_TOPICS } from '@frontend/data-access';
import { Card } from 'antd';
import useTranslation from 'next-translate/useTranslation';

function TrendingTopicsStats() {
  const { t } = useTranslation('admin');

  const { data, loading } = useQuery<{
    dashboardTrendingTopics: {
      name: string;
      value: number;
      type: string;
    }[];
  }>(GET_TRENDING_TOPICS);

  const COLOR_PLATE_10 = [
    '#0273EA',
    '#00CC00',
    '#B1BDC9',
    '#7AC4FC',
    '#C5F1BB',
    '#A3B1BF',
    '#8B8B8B',
    '#1890FF',
  ];

  const config: BarConfig = {
    data: data?.dashboardTrendingTopics || [],
    loading,
    isStack: true,
    xField: 'value',
    yField: 'name',
    seriesField: 'type',
    legend: { position: 'bottom', flipPage: false },
    xAxis: {
      label: {
        style: {
          fontFamily: 'Lufga',
          fill: 'rgba(0, 0, 0, 0.65)',
        },
        labelFormatter: (value) =>
          value.length > 30 ? value.slice(0, 30) + '...' : value,
      },
    },
    label: {
      text: ({ value }) => (value > 0 ? value : ''),
      textBaseline: 'bottom',
      position: 'inside',
      style: {
        fill: 'rgba(255, 255, 255, 1)',
        fontFamily: 'Lufga',
      },
    },
    scale: {
      color: {
        range: COLOR_PLATE_10,
      },
    },
  };

  return (
    <Card
      style={{
        borderRadius: 20,
      }}
    >
      <div className="space-y-5">
        <div className="text-sm text-gray-900 font-medium">
          {t('trending_topics')}
        </div>
        <Bar {...config} />
      </div>
    </Card>
  );
}

export default TrendingTopicsStats;
